// extracted by mini-css-extract-plugin
export default {"numberCell":"NumberCell_numberCell__ECN7d"};